<template>
    <div class="page container">
        <h1 class="is-size-3"><small class="has-text-weight-bold">Cursos</small> </h1>
        <br />
        <input class="input" v-model='tituloCurso' placeholder="Insira o nome do curso" style="max-width: 300px"/>
        <el-button-group>
				  <el-button type="primary" icon="el-icon-plus" @click='novoCurso' > Criar Curso</el-button>
				</el-button-group>
			<hr />
			<el-table
		    :data="cursos"
		    stripe
		    style="width: 100%">
		    <el-table-column
		      prop="id"
		      label="#"
		      width="65">
		      <template slot-scope="scope">
		        <small>{{scope.row.id}}</small>
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="titulo"
		      label="Título">
		      <template slot-scope="scope">
		        <span style="margin-left: 10px"><b>{{scope.row.titulo }}</b></span>
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="inscritos"
		      label="Inscritos"
		      width="150"
		      >
		      <template slot-scope="scope">
		        <span style="margin-left: 10px">{{scope.row.inscritos.length }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="inscricoes_inicio"
		      label="Inicia"
		      width="150"
		      >
		      <template slot-scope="scope">
		      	<i class="el-icon-time"></i>
		        <span style="margin-left: 10px">{{ formatAtualizacao(scope.row.inscricoes_inicio) }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="inscricoes_fim"
		      label="Encerra"
		      width="150"
		      >
		      <template slot-scope="scope">
		      	<i class="el-icon-time"></i>
		        <span style="margin-left: 10px">{{ formatAtualizacao(scope.row.inscricoes_fim) }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column
		      label=""
		      width="160">
		      <template slot-scope="scope">
		      	<div style="float:left">
			        
			        	<el-switch
	              style="height:30px;margin-right:5px;"
	              v-model="scope.row.visivel"
	              active-color="#2CCD06"
	              inactive-color="#FF1D00"
	              @change='toggleSwitch(scope.row)'
	              >
	            </el-switch>
	          </div>
	          <el-button-group>
		        	<el-button type="primary" size="small" @click='openCurso(scope.row)'><i class="fas fa-sign-in-alt" ></i></el-button>
		          <el-button type="danger" size="small"@click='removeCurso(scope.row)' ><i class="fas fa-trash"></i></el-button>
		        </el-button-group>
		      </template>
		    </el-table-column>
		  </el-table>
    </div>
</template>


<script>
import moment from 'moment'
import utils from '@/utils'
import { mapState } from 'vuex'
import Store from '@/store'
import axios from 'axios'


export default {
		watch: {
	    '$route.params': function (params) {
	      this.load(params);
	    }
	  },
	  computed:{
		  ...mapState({
	      disciplinas: state => state.session.disciplinas
	      
	    }),
		},
	  data(){
	  	return {
	  		activeIndex2: '1',
	  		tituloCurso: '',
        cursos: [
        ]
      }
	  },
		methods:{
			openCurso(row){
				this.$router.push(`/admin/curso/${row.id}/conteudos`)
			},
			openNovoDominio(row){
				this.$router.push(`/admin/curso/novo`)
			},
			formatConteudo(conteudos){
				
				const maped = conteudos.map(c=>c.descricao);
				const joined = maped.join(",")
				if(joined == "")
					return "SEM DESCRIÇÃO"
				else
					return joined	
				
			},
			formatAtualizacao(atualizacao){
				return moment(atualizacao).fromNow();
			},
			formatData(data){
				if(data)
					return moment(data).format('DD | MMM')
				else
					return " - "
			},
			parseProva(p){
				const media1 = p.notas.reduce((acc,n)=>{
					const nota = parseFloat(n.nota);
					if(!isNaN(nota)){
						return nota + acc;
					}else{
						return acc;
					}
				},0)
				const numNotas = p.notas.length;
				let media = '-'
				if(numNotas>0){
					media = (media1/numNotas).toFixed(2)
				}
				return {...p, media: media}
			},
			load(params){
				this.course = params.course;
				this.turma = params.turma;
				Store.dispatch('teacher/getAulas', {
        	course: this.course, 
        	turma: this.turma
      	}).then(r=>{
      		this.aulas = r
      	},()=>{} );
      	Store.dispatch('teacher/getProvas', {
        	course: this.course, 
					turma: this.turma
				}).then(r=>{
					this.provas = r.map(this.parseProva);
				},()=>{} );
			},
			handleSelect(key, keyPath) {
				if(keyPath[0] == 'turma'){
					this.turmaLabel = key;
				}else{
					this.turma = key;
				}
				
      },
      getCursos(){
      	global.Loading.begin('Carregando cursos');
      	axios.get(`${global.base}/api/admin/cursos`,{
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
          	
            this.cursos = r.data.map((c) => {
            	return {...c, visivel: c.visivel == 1 ? true : false}
            });
            setTimeout(global.Loading.end, 2500 )
              
          }).catch(()=>{
            global.Loading.end();
          })
      },
      removeCurso(c){
      	this.$confirm('Tem certeza de que deseja excluir permanentemente esse curso?', 'Cuidado', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          global.Loading.begin('Removendo cursos');
		      	axios.delete(`${global.base}/api/admin/curso/${c.id}`,{
	          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
	          }).then((r)=>{
	          	

	            this.cursos = this.cursos.filter(c1 => c1.id != c.id);

	            setTimeout(global.Loading.end, 1500 )
	              
	          }).catch(()=>{
	            global.Loading.end();
	          })
        }).catch(() => {
              
        });
      	
      },
      toggleSwitch(r){
      	if(!r.visivel){
      		this.deactivateCurso(r)
      	}else{
      		this.activateCurso(r)
      	}
      },
      activateCurso(c){
      	this.$confirm('Tornar esse curso visível?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          global.Loading.begin('Definindo curso visível');
		      	axios.get(`${global.base}/api/admin/curso/${c.id}/visivel`,{
	          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
	          }).then((r)=>{
	            
	            setTimeout(global.Loading.end, 1500 )
	              
	          }).catch(()=>{
	            global.Loading.end();
	          })
        }).catch(() => {
              c.visivel = false;
        });
      	
      },
      deactivateCurso(c){
      	this.$confirm('Tornar esse curso invisível?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          global.Loading.begin('Definindo curso invisível');
		      	axios.get(`${global.base}/api/admin/curso/${c.id}/invisivel`,{
	          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
	          }).then((r)=>{
	            
	            setTimeout(global.Loading.end, 1500 )
	              
	          }).catch(()=>{
	            global.Loading.end();
	          })
        }).catch(() => {
              c.visivel = true;
        });
      	
      },

      novoCurso(){
      	global.Loading.begin('Novo curso');
      	axios({
            method: 'post',
            url: `${global.base}/api/admin/curso`,
            data: {
              dados: {
                titulo: this.tituloCurso,
              }
            },
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              global.Loading.end();
              this.tituloCurso = '';
              this.cursos.unshift(r.data)
            }).catch(()=>{
              global.Loading.end();
            })
      	
      }
		},
    mounted(){
			const params = this.$router.currentRoute.params;
			this.getCursos();
    }
};
</script>

<style scoped>

</style>
